module.exports = __webpack_public_path__ + "img/dropdown-icon.54bd86edc5238525d8c38e226cb52eed.svg";